module.exports = __webpack_public_path__ + "static/img/map4.2615836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/divinemap/map4.png
// module id = /Q8t
// module chunks = 1